// ============================================================================
// ContactProfileDialog.tsx — профиль контакта (открывается из карточки).
// Данные и действия — единый сервис контактов; администратору доступен
// переход в карточку пользователя конфигуратора. UI не вызывает RPC сам.
// ============================================================================

import { ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { UniversalWindow } from '@/components/ui/UniversalWindow';
import { navigateTo } from '@/lib/navigate';
import { contactProfileRoute } from '@/lib/contacts/contactService';
import type { ContactAction, ContactDetails } from '@/lib/contacts/types';
import { ContactCard } from './ContactCard';

interface ContactProfileDialogProps {
  details: ContactDetails;
  isAdmin: boolean;
  busyKind?: string;
  onAction: (action: ContactAction) => void;
  onClose: () => void;
}

export function ContactProfileDialog({ details, isAdmin, busyKind, onAction, onClose }: ContactProfileDialogProps) {
  return (
    <UniversalWindow
      open
      onClose={onClose}
      title={`Профиль: ${details.name}`}
      width="max-w-md"
      height="auto"
      resizable={false}
    >
      <div className="space-y-3 p-3">
        <ContactCard details={details} busyKind={busyKind} onAction={onAction} showProfileAction={false} />
        {isAdmin && (
          <Button
            type="button"
            variant="outline"
            size="sm"
            className="h-8 w-full text-[11px]"
            onClick={() => {
              onClose();
              navigateTo(contactProfileRoute(details.id));
            }}
          >
            <ExternalLink className="mr-1.5 h-3.5 w-3.5" />
            Открыть карточку пользователя
          </Button>
        )}
      </div>
    </UniversalWindow>
  );
}
